/* Copyright (c) 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Input, FlexContainer, theme } from "@nordcloud/gnui";
import { FormGroup } from "~/components/Forms";
import { FullWidthContainer } from "~/components/Styled";
import { isNotNil } from "~/tools";
import { EditButtons } from "./EditButtons";
import { InlineLoading } from "./InlineLoading";
import { InlineEditProps, InlineForm } from "./types";

export function InlineText({
  updateHook,
  property,
  updateHookProps,
  type = "text",
  schema,
  value,
  onClose,
  onSuccess,
  placeholder,
}: InlineEditProps) {
  const createSchema = z.object({
    ...schema,
  });

  const { register, handleSubmit, formState } = useForm({
    resolver: zodResolver(createSchema),
  });

  const [update, mutationLoading] = updateHook({
    onSuccess: () => {
      onClose();
      onSuccess?.();
    },
  });

  const onEdit = (newValue: InlineForm) => {
    if (isNotNil(updateHookProps)) {
      update({ ...updateHookProps, value: newValue });
    } else {
      update(newValue);
    }
  };

  if (mutationLoading) {
    return <InlineLoading />;
  }

  const showError = formState.errors[property] !== undefined;

  return (
    <form
      onSubmit={handleSubmit(onEdit)}
      css={{ display: "block", flexGrow: 1 }}
    >
      <FormGroup
        error={formState.errors[property]}
        customCss={{ marginBottom: theme.spacing.spacing01 }}
      >
        <FlexContainer>
          <FullWidthContainer>
            <Input
              type={type}
              {...register(property)}
              small
              status={showError ? "danger" : undefined}
              defaultValue={value?.toString()}
              placeholder={placeholder}
            />
          </FullWidthContainer>
          <EditButtons onClose={onClose} />
        </FlexContainer>
      </FormGroup>
    </form>
  );
}
